var React = require('react');

function CarrotLG (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000976562 1.41519L11.3147 12.7289L22.6284 1.41519L21.2142 0.000976731L11.3147 9.90047L1.41519 0.000976562L0.000976562 1.41519Z","fill":"#5E79FB"}));
}

CarrotLG.defaultProps = {"width":"23","height":"13","viewBox":"0 0 23 13","fill":"none"};

module.exports = CarrotLG;

CarrotLG.default = CarrotLG;
